// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../files/Finlandica-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../files/finlandica-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../files/Finlandica-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../files/finlandica-bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/dot_pattern_dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/dot_pattern_white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/hero_bg_image_2x.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/startup_innovaatioseteli.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/hero_overlay2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'FinlandicaRegular';
	src: local('Finlandica Regular'), local('Finlandica Regular'), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
	font-family: 'FinlandicaBold';
	src: local('Finlandica Bold'), local('Finlandica Bold'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

body {
	font-family: "FinlandicaRegular", Arial, sans-serif !important;
	font-weight: 300 !important;
	color: #002ea2 !important;
	min-width: 360px;
	max-width: 100vw;
}

h1,
h2,
h4 {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
}

p {
	font-weight: normal;
}

.nav-header {
	height: auto;
	min-height: 54px;
}

.btn-primary {
	background-color: #002ea2 !important;
	border-color: #002ea2 !important;
	color: white !important;
}

.btn-secondary {
	border: 2px solid #002ea2 !important;
	color: #002ea2 !important;
	background-color: white !important;
}

.btn {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
	border-radius: 0 !important;
}

.btn-secondary:hover,
.btn-primary:hover {
	background-color: #00aee9 !important;
	border-color: #00aee9 !important;
	color: white !important;
}

.nav-link,
.navbar-brand {
	color: #002ea2 !important;
}

.nav-link.active,
.nav-link:hover {
	color: #00aee9 !important;
}

.nav-link {
	max-width: 145px !important;
}

.collapsebox.show {
	background-color: white;
	z-index: 1;
}

header {
	height: 54px;
	border-bottom: 2px solid #EDEDED;
}

main {
	padding-bottom: 92px;
	min-height: calc(100vh - 54px);
}

footer {
	background-color: #002ea2;
	color: white;
	/* position: absolute; */
	bottom: 0;
	width: 100%
}

.dot-background-light {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) repeat left top;
	background-size: 10px 10px;
}

.dot-background-dark {
	background-color: #f7f7f7 !important;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) repeat left top;
	background-size: 10px 10px;
}

.regButton {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat scroll 0 0 transparent;
	height: 170px;
	background-size: cover;
	max-width: 400px;
	min-width: 350px;
}

.regButton2 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat scroll 0 0 transparent;
	height: 170px;
	background-size: cover;
	max-width: 350px;
	min-width: 250px;
}

.regButtonText {
	font-size: 25px;
	color: white !important;
	overflow-wrap: break-word;
	word-wrap: break-word;
	hyphens: auto;
}

.mainpage-header {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}), url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-size: cover, cover;
	color: white;
	background-color: #002ea2;
}

.mainpage-header h1 {
	font-size: 72px;
}

.mainpage-header p {
	font-size: 22px;
}

@media screen and (max-width: 765px) {
	.mainpage-header h1 {
		font-size: 32px !important;
	}

	.mainpage-header p {
		font-size: 18px !important;
	}

	.footer {
		height: 200px !important;
	}

	main {
		padding-bottom: 200px !important;
	}
}

@media screen and (max-width: 767px) {
	.collapsebox {
		border: solid 1px #e6e6e6;
		width: 100%;
		margin-top: 7px;
	}

	.nav-item {
		border-bottom: solid 1px #e6e6e6;
		padding: 12px 25px 12px 25px;
		margin-left: 1px !important;
	}
}

.contact-area {
	background-color: #f2f2f2;
	padding: 2em;
}

.footer {
	line-height: 92px;
	height: 92px;
	width: 100%;
}

.footer a:hover {
	color: #00aee9 !important;
	text-decoration: none;
}

.footer-left {
	margin-left: 2em;
}

.footer-right {
	margin-right: 2em;
}

.top-margin {
	margin-top: 2em;
}

.bottom-margin {
	margin-bottom: 2em;
}

.bottom-margin-small {
	margin-bottom: 1em;
}

.top-margin-small {
	margin-top: 1em;
}

.right-margin {
	margin-right: 1em;
}

.right-margin-small {
	margin-right: 0.5em;
}

.caps {
	text-transform: uppercase;
}

.lowercase {
	text-transform: lowercase;
}

.bold {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
}

.input-label {
	font-weight: bold;
}

.remove-negative-margin-left {
	margin-left: 0 !important;
}

.tab-content {
	padding: 1em 0;
}

.limit-width-and-center {
	max-width: 750px;
	margin: 0 auto;
}

.wide-limit-width-and-center {
	max-width: 1250px;
	margin: 0 auto;
}

.card-deck>.card>img {
	width: 100%;
}

.person {
	clear: both;

	padding: .75em 0;
}

.person-photo {
	height: 100px;
	width: 100px;
	overflow: hidden;
	border-radius: 50%;
}

.person-photo-img {
	max-width: 100px;
	max-height: 100px;
	object-fit: cover;
}

.photo-div {
	padding-left: 1.5rem;
}

.person-photo-img-horizontal {
	display: inline;
	margin: 0 auto;
	max-height: 80px;
}

.person-info {
	float: right;
	width: 69%;
	padding: 1rem 0 0.5rem 1rem;
}

.person-info-no-photo {
	padding-left: 1rem;
	padding-bottom: 1rem;
}

.light-blue,
.evaluated {
	color: #149de3;
}

.message-input {
	height: 158px;
}



@media (min-width:34em) {
	.card-deck>.card {
		width: 35%;
		flex-wrap: wrap;
		flex: initial !important;
	}
}

.expCard {
	margin: 5px;
}

.expCard:not(:last-child) {
	margin-right: 0 !important;
}

.expCard:not(:first-child) {
	margin-left: 5px !important;
}

.expertcard {
	height: 450px;
	min-width: 310px;
	border: none !important;
	color: #002ea2 !important;
}

.expertcard:hover {
	cursor: pointer;
	box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
}

.expertcard:hover h4 {
	color: #149de3;
}

.expertcard-title {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
	font-size: 20px;
	margin-top: 10px;
}

.expertcard-subtitle {
	font-size: 14px;
}

.expertcard-list-header {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
	font-size: 13px;
}

.expertcard-list-text {
	font-size: 13px;
}

.page-container {
	min-width: 100%;
	max-width: 1000px !important;
}

.divider {
	color: #002da1;
	opacity: 1 !important;
	width: 50px;
	margin: 0 auto;
}

.group-divider {
	border: 1px solid #002da1;
	width: 100%;
}

.evaluated {
	font-family: "FinlandicaBold", Arial, sans-serif !important;
	margin-top: 6px;
	margin-bottom: 0;
	color: #149de3;
	font-size: 12px;
	height: 16px;
	line-height: 1.33;
}

.logo {
	max-height: 70px;
	max-width: 90%;
}

.logo-area {
	padding-top: 10px;
	padding-bottom: 10px;
	min-height: 70px;

}

.closeicon {
	cursor: pointer;
	font-size: 14px;
}

.limit-max-width-to-parent {
	max-width: 100%;
}

.column-header-link {
	cursor: pointer;
}

.column-header-link:hover {
	color: #149de3;
}

.row-link {
	cursor: pointer;
}

.row-link:hover {
	color: #149de3;
}

.flag {
	font-size: 25px;
	position: fixed;
	padding-left: 5px;
	padding-right: 5px;
	margin-top: -5px;
}

.noResults {
	padding: 5px;
	background-color: white;
	color: #cc3510;
}

.backButton {
	margin-left: 1.5rem !important;
	margin-bottom: 0.5rem !important;
}

.counter {
	color: #636c72;
	text-align: right;
}

.showEnter {
	white-space: pre-line;
}

.italic {
	font-style: italic;
}

.description-area {
	height: 120px;
}

.cardStars {
	width: 100%;
	padding-top: 1rem;
	font-size: 13px;
}

.starColumn {
	padding: 3px;
}

.profileStar {
	padding-bottom: 5px;
	padding-top: 5px;
}

.innoStars {
	font-size: x-small;
}

.rating-profile {
	text-align: left;
	padding-top: 1.5rem;
}

.overlay span img {
	animation: grow 0.5s ease-in-out;
}

@keyframes grow {
	0% {
		transform: scale(0);
	}

	50% {
		transform: scale(1.3);
	}

	100% {
		transform: scale(1)
	}
}

.invalid-feedback-new {
	display: block;
	width: 100%;
	margin-top: 0.25rem;
	font-size: 80%;
	color: #dc3545;
}

/* replicates the removed reactstrap Jumbotron styles */
.jumbotron-1 {
	padding: 2rem 1rem;
	margin-bottom: 2rem;
	background-color: #e9ecef;
	border-radius: 0.3rem;
}

@media (min-width: 576px) {
	.jumbotron-1 {
		padding: 4rem 2rem;
	}
}

.dropzone {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	border-width: 2px;
	border-radius: 2px;
	border-color: #eeeeee;
	border-style: dashed;
	background-color: #fafafa;
	color: #bdbdbd;
	outline: none;
	transition: border .24s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./public/styles/main.css"],"names":[],"mappings":"AAAA;CACC,gCAAgC;CAChC,kKAAgK;AACjK;;AAEA;CACC,6BAA6B;CAC7B,4JAAoJ;AACrJ;;AAEA;CACC,8DAA8D;CAC9D,2BAA2B;CAC3B,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;;CAGC,2DAA2D;AAC5D;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;CAChC,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;CACC,2DAA2D;CAC3D,2BAA2B;AAC5B;;AAEA;;CAEC,oCAAoC;CACpC,gCAAgC;CAChC,uBAAuB;AACxB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,oBAAoB;CACpB,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;CACzB,YAAY;CACZ,wBAAwB;CACxB,SAAS;CACT;AACD;;AAEA;CACC,mEAA+D;CAC/D,0BAA0B;AAC3B;;AAEA;CACC,oCAAoC;CACpC,mEAAgE;CAChE,0BAA0B;AAC3B;;AAEA;CACC,oFAAgF;CAChF,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,oFAAwF;CACxF,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,uBAAuB;CACvB,yBAAyB;CACzB,qBAAqB;CACrB,aAAa;AACd;;AAEA;CACC,4FAAkF;CAClF,6BAA6B;CAC7B,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,gCAAgC;CACjC;AACD;;AAEA;CACC;EACC,yBAAyB;EACzB,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B;CAC5B;AACD;;AAEA;CACC,yBAAyB;CACzB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2DAA2D;AAC5D;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;;CAEX,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,UAAU;CACV,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;;;AAIA;CACC;EACC,UAAU;EACV,eAAe;EACf,wBAAwB;CACzB;AACD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,2DAA2D;CAC3D,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,2DAA2D;CAC3D,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,2DAA2D;CAC3D,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,gBAAgB;;AAEjB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC;EACC,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC;CACD;AACD;;AAEA;CACC,cAAc;CACd,WAAW;CACX,mBAAmB;CACnB,cAAc;CACd,cAAc;AACf;;AAEA,uDAAuD;AACvD;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,oBAAoB;CACpB,yBAAyB;CACzB,cAAc;CACd,aAAa;CACb,mCAAmC;AACpC","sourcesContent":["@font-face {\n\tfont-family: 'FinlandicaRegular';\n\tsrc: local('Finlandica Regular'), local('Finlandica Regular'), url('../files/Finlandica-Regular.ttf') format('truetype'), url('../files/finlandica-regular.eot');\n}\n\n@font-face {\n\tfont-family: 'FinlandicaBold';\n\tsrc: local('Finlandica Bold'), local('Finlandica Bold'), url('../files/Finlandica-Bold.ttf') format('truetype'), url('../files/finlandica-bold.eot');\n}\n\nbody {\n\tfont-family: \"FinlandicaRegular\", Arial, sans-serif !important;\n\tfont-weight: 300 !important;\n\tcolor: #002ea2 !important;\n\tmin-width: 360px;\n\tmax-width: 100vw;\n}\n\nh1,\nh2,\nh4 {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n}\n\np {\n\tfont-weight: normal;\n}\n\n.nav-header {\n\theight: auto;\n\tmin-height: 54px;\n}\n\n.btn-primary {\n\tbackground-color: #002ea2 !important;\n\tborder-color: #002ea2 !important;\n\tcolor: white !important;\n}\n\n.btn-secondary {\n\tborder: 2px solid #002ea2 !important;\n\tcolor: #002ea2 !important;\n\tbackground-color: white !important;\n}\n\n.btn {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n\tborder-radius: 0 !important;\n}\n\n.btn-secondary:hover,\n.btn-primary:hover {\n\tbackground-color: #00aee9 !important;\n\tborder-color: #00aee9 !important;\n\tcolor: white !important;\n}\n\n.nav-link,\n.navbar-brand {\n\tcolor: #002ea2 !important;\n}\n\n.nav-link.active,\n.nav-link:hover {\n\tcolor: #00aee9 !important;\n}\n\n.nav-link {\n\tmax-width: 145px !important;\n}\n\n.collapsebox.show {\n\tbackground-color: white;\n\tz-index: 1;\n}\n\nheader {\n\theight: 54px;\n\tborder-bottom: 2px solid #EDEDED;\n}\n\nmain {\n\tpadding-bottom: 92px;\n\tmin-height: calc(100vh - 54px);\n}\n\nfooter {\n\tbackground-color: #002ea2;\n\tcolor: white;\n\t/* position: absolute; */\n\tbottom: 0;\n\twidth: 100%\n}\n\n.dot-background-light {\n\tbackground: url(../images/dot_pattern_dark.svg) repeat left top;\n\tbackground-size: 10px 10px;\n}\n\n.dot-background-dark {\n\tbackground-color: #f7f7f7 !important;\n\tbackground: url(../images/dot_pattern_white.svg) repeat left top;\n\tbackground-size: 10px 10px;\n}\n\n.regButton {\n\tbackground: url(../images/hero_bg_image_2x.jpg) no-repeat scroll 0 0 transparent;\n\theight: 170px;\n\tbackground-size: cover;\n\tmax-width: 400px;\n\tmin-width: 350px;\n}\n\n.regButton2 {\n\tbackground: url(../images/startup_innovaatioseteli.jpg) no-repeat scroll 0 0 transparent;\n\theight: 170px;\n\tbackground-size: cover;\n\tmax-width: 350px;\n\tmin-width: 250px;\n}\n\n.regButtonText {\n\tfont-size: 25px;\n\tcolor: white !important;\n\toverflow-wrap: break-word;\n\tword-wrap: break-word;\n\thyphens: auto;\n}\n\n.mainpage-header {\n\tbackground: url(../images/hero_overlay2x.png), url(../images/hero_bg_image_2x.jpg);\n\tbackground-size: cover, cover;\n\tcolor: white;\n\tbackground-color: #002ea2;\n}\n\n.mainpage-header h1 {\n\tfont-size: 72px;\n}\n\n.mainpage-header p {\n\tfont-size: 22px;\n}\n\n@media screen and (max-width: 765px) {\n\t.mainpage-header h1 {\n\t\tfont-size: 32px !important;\n\t}\n\n\t.mainpage-header p {\n\t\tfont-size: 18px !important;\n\t}\n\n\t.footer {\n\t\theight: 200px !important;\n\t}\n\n\tmain {\n\t\tpadding-bottom: 200px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.collapsebox {\n\t\tborder: solid 1px #e6e6e6;\n\t\twidth: 100%;\n\t\tmargin-top: 7px;\n\t}\n\n\t.nav-item {\n\t\tborder-bottom: solid 1px #e6e6e6;\n\t\tpadding: 12px 25px 12px 25px;\n\t\tmargin-left: 1px !important;\n\t}\n}\n\n.contact-area {\n\tbackground-color: #f2f2f2;\n\tpadding: 2em;\n}\n\n.footer {\n\tline-height: 92px;\n\theight: 92px;\n\twidth: 100%;\n}\n\n.footer a:hover {\n\tcolor: #00aee9 !important;\n\ttext-decoration: none;\n}\n\n.footer-left {\n\tmargin-left: 2em;\n}\n\n.footer-right {\n\tmargin-right: 2em;\n}\n\n.top-margin {\n\tmargin-top: 2em;\n}\n\n.bottom-margin {\n\tmargin-bottom: 2em;\n}\n\n.bottom-margin-small {\n\tmargin-bottom: 1em;\n}\n\n.top-margin-small {\n\tmargin-top: 1em;\n}\n\n.right-margin {\n\tmargin-right: 1em;\n}\n\n.right-margin-small {\n\tmargin-right: 0.5em;\n}\n\n.caps {\n\ttext-transform: uppercase;\n}\n\n.lowercase {\n\ttext-transform: lowercase;\n}\n\n.bold {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n}\n\n.input-label {\n\tfont-weight: bold;\n}\n\n.remove-negative-margin-left {\n\tmargin-left: 0 !important;\n}\n\n.tab-content {\n\tpadding: 1em 0;\n}\n\n.limit-width-and-center {\n\tmax-width: 750px;\n\tmargin: 0 auto;\n}\n\n.wide-limit-width-and-center {\n\tmax-width: 1250px;\n\tmargin: 0 auto;\n}\n\n.card-deck>.card>img {\n\twidth: 100%;\n}\n\n.person {\n\tclear: both;\n\n\tpadding: .75em 0;\n}\n\n.person-photo {\n\theight: 100px;\n\twidth: 100px;\n\toverflow: hidden;\n\tborder-radius: 50%;\n}\n\n.person-photo-img {\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tobject-fit: cover;\n}\n\n.photo-div {\n\tpadding-left: 1.5rem;\n}\n\n.person-photo-img-horizontal {\n\tdisplay: inline;\n\tmargin: 0 auto;\n\tmax-height: 80px;\n}\n\n.person-info {\n\tfloat: right;\n\twidth: 69%;\n\tpadding: 1rem 0 0.5rem 1rem;\n}\n\n.person-info-no-photo {\n\tpadding-left: 1rem;\n\tpadding-bottom: 1rem;\n}\n\n.light-blue,\n.evaluated {\n\tcolor: #149de3;\n}\n\n.message-input {\n\theight: 158px;\n}\n\n\n\n@media (min-width:34em) {\n\t.card-deck>.card {\n\t\twidth: 35%;\n\t\tflex-wrap: wrap;\n\t\tflex: initial !important;\n\t}\n}\n\n.expCard {\n\tmargin: 5px;\n}\n\n.expCard:not(:last-child) {\n\tmargin-right: 0 !important;\n}\n\n.expCard:not(:first-child) {\n\tmargin-left: 5px !important;\n}\n\n.expertcard {\n\theight: 450px;\n\tmin-width: 310px;\n\tborder: none !important;\n\tcolor: #002ea2 !important;\n}\n\n.expertcard:hover {\n\tcursor: pointer;\n\tbox-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);\n}\n\n.expertcard:hover h4 {\n\tcolor: #149de3;\n}\n\n.expertcard-title {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n\tfont-size: 20px;\n\tmargin-top: 10px;\n}\n\n.expertcard-subtitle {\n\tfont-size: 14px;\n}\n\n.expertcard-list-header {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n\tfont-size: 13px;\n}\n\n.expertcard-list-text {\n\tfont-size: 13px;\n}\n\n.page-container {\n\tmin-width: 100%;\n\tmax-width: 1000px !important;\n}\n\n.divider {\n\tcolor: #002da1;\n\topacity: 1 !important;\n\twidth: 50px;\n\tmargin: 0 auto;\n}\n\n.group-divider {\n\tborder: 1px solid #002da1;\n\twidth: 100%;\n}\n\n.evaluated {\n\tfont-family: \"FinlandicaBold\", Arial, sans-serif !important;\n\tmargin-top: 6px;\n\tmargin-bottom: 0;\n\tcolor: #149de3;\n\tfont-size: 12px;\n\theight: 16px;\n\tline-height: 1.33;\n}\n\n.logo {\n\tmax-height: 70px;\n\tmax-width: 90%;\n}\n\n.logo-area {\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\tmin-height: 70px;\n\n}\n\n.closeicon {\n\tcursor: pointer;\n\tfont-size: 14px;\n}\n\n.limit-max-width-to-parent {\n\tmax-width: 100%;\n}\n\n.column-header-link {\n\tcursor: pointer;\n}\n\n.column-header-link:hover {\n\tcolor: #149de3;\n}\n\n.row-link {\n\tcursor: pointer;\n}\n\n.row-link:hover {\n\tcolor: #149de3;\n}\n\n.flag {\n\tfont-size: 25px;\n\tposition: fixed;\n\tpadding-left: 5px;\n\tpadding-right: 5px;\n\tmargin-top: -5px;\n}\n\n.noResults {\n\tpadding: 5px;\n\tbackground-color: white;\n\tcolor: #cc3510;\n}\n\n.backButton {\n\tmargin-left: 1.5rem !important;\n\tmargin-bottom: 0.5rem !important;\n}\n\n.counter {\n\tcolor: #636c72;\n\ttext-align: right;\n}\n\n.showEnter {\n\twhite-space: pre-line;\n}\n\n.italic {\n\tfont-style: italic;\n}\n\n.description-area {\n\theight: 120px;\n}\n\n.cardStars {\n\twidth: 100%;\n\tpadding-top: 1rem;\n\tfont-size: 13px;\n}\n\n.starColumn {\n\tpadding: 3px;\n}\n\n.profileStar {\n\tpadding-bottom: 5px;\n\tpadding-top: 5px;\n}\n\n.innoStars {\n\tfont-size: x-small;\n}\n\n.rating-profile {\n\ttext-align: left;\n\tpadding-top: 1.5rem;\n}\n\n.overlay span img {\n\tanimation: grow 0.5s ease-in-out;\n}\n\n@keyframes grow {\n\t0% {\n\t\ttransform: scale(0);\n\t}\n\n\t50% {\n\t\ttransform: scale(1.3);\n\t}\n\n\t100% {\n\t\ttransform: scale(1)\n\t}\n}\n\n.invalid-feedback-new {\n\tdisplay: block;\n\twidth: 100%;\n\tmargin-top: 0.25rem;\n\tfont-size: 80%;\n\tcolor: #dc3545;\n}\n\n/* replicates the removed reactstrap Jumbotron styles */\n.jumbotron-1 {\n\tpadding: 2rem 1rem;\n\tmargin-bottom: 2rem;\n\tbackground-color: #e9ecef;\n\tborder-radius: 0.3rem;\n}\n\n@media (min-width: 576px) {\n\t.jumbotron-1 {\n\t\tpadding: 4rem 2rem;\n\t}\n}\n\n.dropzone {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 20px;\n\tborder-width: 2px;\n\tborder-radius: 2px;\n\tborder-color: #eeeeee;\n\tborder-style: dashed;\n\tbackground-color: #fafafa;\n\tcolor: #bdbdbd;\n\toutline: none;\n\ttransition: border .24s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
